import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "../ui/form";
import { LoginFormData, loginFormSchema } from "./schemas"
import { Input } from "../ui/input";
import { InputPassword } from "../ui/input-password";
import { LogIn } from 'lucide-react';
import { Button } from "../ui/button";
import { Link, useLocation } from "wouter";
import { useLogin } from "@/services/queries/useAuth";
import { useAuthContext } from "@/context/authentication/auth-context";
import { TokenStorage } from "@shared/handle-local-storage";
import { useEffect } from "react";

export function LoginForm() {

  const [_, navigate] = useLocation()

  const { getAuthenticatedUser, person } = useAuthContext()

  useEffect(() => {
    if (person) {
      navigate('/')
    }
  }, [person])

  const form = useForm({
    resolver: zodResolver(loginFormSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const { mutateAsync: login, isPending } = useLogin()

  const onLoginSubmit = async (data: LoginFormData) => {
    await login({ login: data.email, password: data.password }).then((res) => {
      TokenStorage.set(res.access_token)
      getAuthenticatedUser()
    })
  };

  return (
    <Form {...form}>
      <form className="space-y-2.5 2xl:space-y-4" onSubmit={form.handleSubmit(onLoginSubmit)}>
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>E-mail</FormLabel>
              <FormControl>
                <Input type="email" placeholder="contato@cineblocks.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Senha</FormLabel>
              <FormControl>
                <InputPassword field={field} placeholder="********" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="text-left text-sm">
          <Link href="/esqueci-minha-senha" className="text-primary hover:underline">
            Esqueceu sua senha?
          </Link>
        </div>

        <Button
          type="submit"
          size={"default"}
          isLoading={isPending}
          disabled={isPending}
          children={<>
            <LogIn className="w-4 h-4" /> Login
          </>}
          className="w-full"
        />
      </form>
    </Form>
  );
}
